
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kontakty",
      function () {
        return require("private-next-pages/kontakty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kontakty"])
      });
    }
  